import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import SSBO_VALUES from 'root/global_configs/ssbo_values.json';
import { appendParamsToUrl } from 'root/utils/URLParams/URLParams';

const RETAIL_FREE_TRIAL_WIZARD = '#lightbox|retail-free-trial-wizard-lightbox';

export const TRIAL_REQUEST_FORM_NAME = SSBO_VALUES.FREE_TRIAL.form_name_set_by_cta;

const exportedForUnitTesting = () => ({
    shouldRedirectToAccounts,
    swapLinks,
    setFormNameCookie,
    appendParamsToUrl,
});

const shouldRedirectToAccounts = (): boolean => {
    if (document.body.dataset.domain !== 'hq') return false;

    const cm = new CookieMonster();
    const geo = cm.getCookie('geoConfig');
    const countryCode = geo?.country_code?.toUpperCase() ?? '';
    const stateCode = geo?.state_code?.toUpperCase() ?? '';

    if (countryCode === 'US') return true;
    return countryCode === 'CA' && stateCode !== 'QC';
};

const setFormNameCookie = () => {
    const key = Object.keys(SSBO_VALUES.FREE_TRIAL)[0];
    window.registerCookieComplianceCallback({
        callback: () => {
            const cm = new CookieMonster({ useDomain: true });
            cm.setCookie(key, TRIAL_REQUEST_FORM_NAME);
        },
        category: 'necessary',
        isCallOptanonWrapper: true,
    });
};

const swapLinks = () => {
    if (isMobileLinkSwapsExcluded()) return;

    const redirectUrl = document.body.dataset.retailFreeTrialAccountsRedirectUrl;
    if (!redirectUrl) return;

    const redirectUrlWithParams = appendParamsToUrl(redirectUrl, SSBO_VALUES.FREE_TRIAL);

    const retailFreeTrialLinks: HTMLAnchorElement[] = Array.from(
        document.querySelectorAll(`a[href*="${RETAIL_FREE_TRIAL_WIZARD}"]`)
    );
    retailFreeTrialLinks.forEach(link => {
        if (link.hasAttribute('data-vwo-exclude')) return;
        if (link.dataset.formNameCookieBound !== 'true') {
            link.addEventListener('click', setFormNameCookie);
            link.dataset.formNameCookieBound = 'true';
        }
        link.href = redirectUrlWithParams;
        link.dataset.ssboFreeTrialCta = 'true';
    });
};

function swapRetailFreeTrialLinksForAccountsRedirect() {
    if (!shouldRedirectToAccounts()) return;
    if (document.body.dataset.retailFreeTrialAccountsRedirect !== 'enabled') return;

    swapLinks();

    const observer = new MutationObserver(() => swapLinks());
    observer.observe(document.body, { childList: true, subtree: true });

    window.addEventListener('load', () => {
        setTimeout(() => observer.disconnect(), 10000);
    });
}

function isMobileLinkSwapsExcluded(): boolean {
    const mobileRetailFreeTrialAccountsRedirect =
        document.body.dataset.mobileRetailFreeTrialAccountsRedirect;
    if (!mobileRetailFreeTrialAccountsRedirect) {
        return false;
    }
    if (mobileRetailFreeTrialAccountsRedirect === 'disabled' && window.innerWidth < 960) {
        return true;
    }
    return false;
}

export { swapRetailFreeTrialLinksForAccountsRedirect, exportedForUnitTesting };
